import React, { useEffect, useRef, useState } from 'react';
import { useSurveyStore } from '../../surveyutilities/surveyStore';

export function QuestionHeading({ block, position }) {
    const updateQuestion = useSurveyStore((state) => state.updateQuestion);
    const [editingTitle, setEditingTitle] = useState(false);
    const [editingDescription, setEditingDescription] = useState(false);
    const titleRef = useRef(null);
    const descriptionRef = useRef(null);

    useEffect(() => {
        if (editingTitle && titleRef.current) titleRef.current.focus();
    }, [editingTitle]);

    useEffect(() => {
        if (editingDescription && descriptionRef.current) descriptionRef.current.focus();
    }, [editingDescription]);

    return (
        <div className="ecx-survey-q__heading">
            {editingTitle ? (
                <input
                    ref={titleRef}
                    type="text"
                    className="form-control form-control-sm ecx-survey-q__title-input"
                    value={block.title || ''}
                    onChange={(e) => updateQuestion(block.internalId, { title: e.target.value })}
                    onBlur={() => setEditingTitle(false)}
                    onClick={(e) => e.stopPropagation()}
                />
            ) : (
                <button
                    type="button"
                    className="ecx-survey-q__title"
                    onClick={(e) => {
                        e.stopPropagation();
                        setEditingTitle(true);
                    }}
                >
                    <span className="ecx-survey-q__num">{position + 1}.</span>
                    <span>{block.title || 'Untitled question'}</span>
                    {block.required ? <span className="ecx-survey-q__required">*</span> : null}
                </button>
            )}

            {editingDescription ? (
                <textarea
                    ref={descriptionRef}
                    className="form-control form-control-sm ecx-survey-q__desc-input"
                    rows={2}
                    value={block.description || ''}
                    onChange={(e) =>
                        updateQuestion(block.internalId, { description: e.target.value })
                    }
                    onBlur={() => setEditingDescription(false)}
                    onClick={(e) => e.stopPropagation()}
                />
            ) : (
                <button
                    type="button"
                    className="ecx-survey-q__desc"
                    onClick={(e) => {
                        e.stopPropagation();
                        setEditingDescription(true);
                    }}
                >
                    {block.description || 'Add a description…'}
                </button>
            )}
        </div>
    );
}

export function QuestionOptionsList({ block, control = 'radio' }) {
    const updateQuestion = useSurveyStore((state) => state.updateQuestion);
    const options = Array.isArray(block.options) ? block.options : [];

    const handleOptionChange = (optionId, newText) => {
        updateQuestion(block.internalId, {
            options: options.map((opt) =>
                opt.id === optionId ? { ...opt, text: newText } : opt
            ),
        });
    };

    const addOption = (event) => {
        event.stopPropagation();
        updateQuestion(block.internalId, {
            options: [
                ...options,
                {
                    id: `opt_${Date.now()}`,
                    text: `Option ${options.length + 1}`,
                    value: `option_${options.length + 1}`,
                },
            ],
        });
    };

    const removeOption = (event, optionId) => {
        event.stopPropagation();
        if (options.length <= 1) return;
        updateQuestion(block.internalId, {
            options: options.filter((opt) => opt.id !== optionId),
        });
    };

    return (
        <div className="ecx-survey-q__options" onClick={(e) => e.stopPropagation()}>
            {options.map((option) => (
                <div key={option.id} className="ecx-survey-q__option">
                    <span className={`ecx-survey-q__control ecx-survey-q__control--${control}`} />
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={option.text || ''}
                        onChange={(e) => handleOptionChange(option.id, e.target.value)}
                    />
                    <button
                        type="button"
                        className="ecx-survey-q__option-remove"
                        title="Remove option"
                        disabled={options.length <= 1}
                        onClick={(e) => removeOption(e, option.id)}
                    >
                        <i className="bi bi-x-lg" />
                    </button>
                </div>
            ))}
            <button
                type="button"
                className="btn btn-sm btn-outline-primary rounded-pill"
                onClick={addOption}
            >
                <i className="bi bi-plus-circle me-1" />
                Add option
            </button>
        </div>
    );
}

export function QuestionPreviewField({ children }) {
    return <div className="ecx-survey-q__preview">{children}</div>;
}
